<template>
    <div class="addadvertMain">
        <div>
            <el-form :model="adverForm" ref="form" :inline="false" size="normal" :label-position="'top'">
                <el-form-item label="广告标题">
                    <el-input v-model="adverForm.title" placeholder="" size="normal" clearable @change=""></el-input>
                </el-form-item>
                <el-form-item label="链接">
                    <el-input v-model="adverForm.url" placeholder="" size="normal" clearable @change=""></el-input>
                </el-form-item>
                <el-form-item label="展示位置">
                    <el-checkbox-group v-model="adverForm.showPageList">
                        <el-checkbox label="扫码成功"></el-checkbox>
                        <el-checkbox label="充电开始"></el-checkbox>
                        <el-checkbox label="问题反馈"></el-checkbox>
                        <el-checkbox label="订单列表"></el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="上传图片">
                    <el-upload class="avatar-uploader" :action="uploadUrl"
                        :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
                        method="post" enctype="multipart/form-data" :data="{ business: 'advert' }"
                        :headers="{ token: token }">
                        <img v-if="fileUrl" :src="fileUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item class="formButton">
                    <el-button @click="onCancel">取消</el-button>
                    <el-button type="primary" @click="onSubmit">确定</el-button>
                    
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
import { addAdvertList, editAdvert } from '@/api/newApi.js'
import { Toast } from "vant";
import "vant/lib/toast/style/index";
import  base  from '@/utils/base';
export default {
    data() {
        return {
            adverForm: {
                title: "",
                url: "",
                showPage: "",
                fileId: "",
                showPageList: []
            },
            form: {},
            token: "",
            fileUrl: "",
          uploadUrl:""
        }
    },
    mounted() {
        this.token = window.localStorage.getItem('token')
        this.uploadUrl = base.bd + "/file/uploadImg"
        if (this.$route.query.id) {
            this.adverForm = {
                ...this.adverForm,
                ...this.$route.query
            }
            this.fileUrl = this.$route.query.fileUrl
        }
    },
    methods: {
        handleAvatarSuccess(res, file) {
            console.log(res);
            this.adverForm.fileId = res.data.imgID
            this.fileUrl = URL.createObjectURL(file.raw);
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                Toast('上传图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
                Toast('上传图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },
        checked(EVEN) {
            console.log(EVEN);
        },
        onSubmit() {
            if (this.$route.query.id) {
                editAdvert(this.adverForm).then(res => {
                    if (res.message.status == 200) {
                        Toast('修改成功')
                        this.$router.push(
                            {
                                path: "/admin/advert"
                            }
                        )
                    }
                })
            } else {
                addAdvertList(this.adverForm).then(res => {
                    if (res.message.status == 200) {
                        Toast('添加成功')
                        this.$router.push(
                            {
                                path: "/admin/advert"
                            }
                        )
                    }
                    console.log(res);
                })
            }
        },
        onCancel() {
            this.$router.push(
                {
                    path: "/admin/advert"
                }
            )
        }
    },
}
</script>
<style lang="scss" scoped>
@import"@/assets/sass/state.scss";

.addadvertMain {
    padding: .4167rem;

    .avatar-uploader {
        ::v-deep .el-upload {
            border: 1px dashed $buttonColor;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }

        .el-upload:hover {
            border-color: #409EFF;
        }

        .avatar-uploader-icon {
            font-size: .3889rem;
            color: $buttonColor;
            width: 2.4722rem;
            height: 2.4722rem;
            line-height: 2.4722rem;
            text-align: center;
        }
    }

    .avatar {
        width: 2.4722rem;
        height: 2.4722rem;
        display: block;
    }

    ::v-deep .el-input__inner,
    ::v-deep .el-checkbox__inner {
        background-color: #0D1A3C;
        border-color: transparent;
        color: #A2BDE1;
    }

    ::v-deep .el-form-item__label {
        color: #7E85A7;
    }

    ::v-deep .el-form-item__content {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        font-size: .2222rem;
        overflow: hidden;
    }

    .formButton {
        ::v-deep .el-button {
            background-color: transparent;
            color: $buttonColor;
            width: 45%;
        }
    }

    ::v-deep .el-checkbox {
        margin-right: .2083rem;
    }
}
</style>